import SaveIcon from '@mui/icons-material/Save';
import { Box, Button, Chip, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Swal from 'sweetalert2';
import axios from '../../../utils/axios';
import CMSFICTEmployees from '../../../utils/strings/CMSFICTEmployees';
import { getUserId } from '../../../utils/strings/userString';

const SettlementCheckList = ({ onChecklistChange, settlementId, claimStatus, claimType, checklistData }) => {
  const checklistItems = [
    {
      name:"shareCertificate", 
      title:"Share Certificate"
    },
    {
      name:"bankChequeLeaf", 
      title:"Bank Cheque Leaf"
    },
    {
      name:"issuerCompanyLetterSignatureVerification", 
      title:"Issuer Company's Letter (Signature Verification)"
    },
    {
      name:"nid", 
      title:"NID"
    },
    {
      name:"boSetup", 
      title:"BO Setup"
    },
    {
      name:"authorizationLetterDulySigned", 
      title:"Authorization Letter (Duly Signed)"
    },
    {
      name:"nidOfAuthorizer", 
      title:"NID of Authorizer"
    },
    {
      name:"poaLetterDulySigned", 
      title:"PoA Letter (Duly Signed)"
    },
    {
      name:"nidOfPoa", 
      title:"NID of PoA"
    },
    {
      name:"deathCertificate", 
      title:"Death Certificate"
    },
    {
      name:"nomineeOrSuccessorApplication", 
      title:"Nominee / Successor Application"
    },
    {
      name:"photocopyOfSuccessionCertificate", 
      title:"Photocopy of Succession Certificate"
    },
    {
      name:"nidPhotocopyOfSuccessor", 
      title:"NID Photocopy of Successor"
    },
    
  ];

  // Initialize with checklistData directly
  const [answers, setAnswers] = useState(checklistData || {
    "shareCertificate": null,
    "bankChequeLeaf": null,
    "issuerCompanyLetterSignatureVerification": null,
    "nid": null,
    "boSetup": null,
    "authorizationLetterDulySigned": null,
    "nidOfAuthorizer": null,
    "poaLetterDulySigned": null,
    "nidOfPoa": null,
    "deathCertificate": null,
    "nomineeOrSuccessorApplication": null,
    "photocopyOfSuccessionCertificate": null,
    "nidPhotocopyOfSuccessor": null,
    
  });
  const baseChecklistKeys = [
      "shareCertificate",
      "bankChequeLeaf",
      "issuerCompanyLetterSignatureVerification",
      "nid",
      "boSetup",
      "authorizationLetterDulySigned",
      "nidOfAuthorizer",
      "poaLetterDulySigned",
      "nidOfPoa",
      "deathCertificate",
      "nomineeOrSuccessorApplication",
      "photocopyOfSuccessionCertificate",
      "nidPhotocopyOfSuccessor",
      
    ];

  const [saving, setSaving] = useState(false);
  const [settlementPermissionsList, setSettlementPermissionsList] = useState([]);


   

  const enabledStatuses = ['Uploaded', 'Drafted', 'Sent_Back','Bounced'];

  const userId = getUserId();

  const CheckListPermission = () => {
  // const adminIds = CMSFICTEmployees;
  // if (adminIds.includes(userId)) return true;
  const permission = settlementPermissionsList.find(p => p.claimStatus === "Checklist_Entry" && p.status === true);
  console.log(permission);
  if (!permission) return false;
  
  return permission.status;
}
const fetchPermissionList = async () => {
  try {
    const  SettlementPermissionList = await axios.get(`/settlement-permissions/user/${userId}`);
    setSettlementPermissionsList(SettlementPermissionList.data.payload);
  } catch (error) {
    console.error("Error fetching settlement permissions:", error);
    setSettlementPermissionsList([]);
  }
};
  // let permittedUserId = CMSFICTEmployees;
  // const canAccess = permittedUserId.includes(getUserId()) || getUserId() === "e2f78434-9b68-478a-b5f7-d5e3709e031d";
  const isButtonEnabled = enabledStatuses.includes(claimStatus) && CheckListPermission();

  // Only update answers when checklistData changes from parent (initial load)
  useEffect(() => {
    if (checklistData && Object.keys(checklistData).length > 0) {
      setAnswers(checklistData);
    }
    else{
      if (claimType === 1) {
      setAnswers({
        "shareCertificate": true,
        "bankChequeLeaf": true,
        "issuerCompanyLetterSignatureVerification": true,
        "nid": true,
        "boSetup": true,
        "authorizationLetterDulySigned": false,
        "nidOfAuthorizer": false,
        "poaLetterDulySigned": false,
        "nidOfPoa": false,
        "deathCertificate": false,
        "nomineeOrSuccessorApplication": false,
        "photocopyOfSuccessionCertificate": false,
        "nidPhotocopyOfSuccessor": false,
        
      });
    }
    else if (claimType === 2) {
      setAnswers({
        "shareCertificate": true,
        "bankChequeLeaf": true,
        "issuerCompanyLetterSignatureVerification": true,
        "nid": true,
        "boSetup": true,
        "authorizationLetterDulySigned": true,
        "nidOfAuthorizer": true,
        "poaLetterDulySigned": true,
        "nidOfPoa": true,
        "deathCertificate": false,
        "nomineeOrSuccessorApplication": false,
        "photocopyOfSuccessionCertificate": false,
        "nidPhotocopyOfSuccessor": false,
        
      });
    }
    else if (claimType === 3) {
      setAnswers({
        "shareCertificate": true,
        "bankChequeLeaf": true,
        "issuerCompanyLetterSignatureVerification": true,
        "nid": true,
        "boSetup": true,
        "authorizationLetterDulySigned": false,
        "nidOfAuthorizer": false,
        "poaLetterDulySigned": false,
        "nidOfPoa": false,
        "deathCertificate": false,
        "nomineeOrSuccessorApplication": true,
        "photocopyOfSuccessionCertificate": true,
        "nidPhotocopyOfSuccessor": true,
        
      });
    }
    }
    fetchPermissionList();
  }, [checklistData,claimType]); // Remove onChecklistChange from dependencies

  

  const handleSelect = (item, value) => {
    const newAnswers = {
      ...answers,
      [item.name]: value,
    };
    setAnswers(newAnswers);
    
    // Notify parent immediately when user makes a selection
    if (onChecklistChange) {
      onChecklistChange(newAnswers);
    }
  };

  const handleSave = async () => {
    
    const nonBooleanItems = baseChecklistKeys.filter(
      (key) => typeof answers[key] !== 'boolean'
    );
    if (nonBooleanItems.length > 0 ) {
          Swal.fire({
            customClass: { container: "my-swal" },
            title: "Invalid Checklist Data",
            html: `
              <div style="text-align: left; line-height: 1.6;">
              <ul>
              <li>
                <strong>Please ensure all checklist items have valid Yes/No answers.</strong></li><br>
                <li><strong>After Selecting Yes/No you must click the Save Checklist button to save your answers.</strong></li>
                </ul>
              </div>
            `,
            icon: "warning",
          });
          return;
        }
        setSaving(true);
    try {
      const payload = {
        ...answers,
        settlementMstId: settlementId,
      };

      const response = await axios.post('/claim-checklist/save', payload);
      
      if(response.data.statusCode === 200) {
        Swal.fire({
          customClass: { container: "my-swal" },
          icon: 'success',
          title: 'Success',
          text: `${response.data.payload.message}`,
        });
        // No need to call onChecklistChange here since it's already updated in handleSelect
      }
    } catch (error) {
      console.error("Error saving checklist", error);
      Swal.fire({
        customClass: { container: "my-swal" },
        icon: 'error',
        title: 'Error',
        text: `${error.message}`,
      });
    } finally {
      setSaving(false);
    }
  }

  return (
    <Box sx={{ padding: 0, margin: 0 }}>
      <Typography variant="h6" gutterBottom>
        Settlement Checklist
      </Typography>
      <Grid container spacing={1}>
        {checklistItems.map((item) => (
          <Grid item xs={12} key={item.name}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 0,
                margin: 0
              }}
            >
              <Typography sx={{ fontSize: "14px" }}>{item.title}:</Typography>
              <Box>
                <Chip
                  label="Yes"
                  color="success"
                  variant={answers[item.name] === true ? "filled" : "outlined"}
                  onClick={() => handleSelect(item, true)}
                  sx={{ mx: 0.5 }}
                />
                <Chip
                  label="No"
                  color="error"
                  variant={answers[item.name] === false ? "filled" : "outlined"}
                  onClick={() => handleSelect(item, false)}
                  sx={{ mx: 0.5 }}
                />
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
      <Grid item xs={12} sx={{ textAlign: "right", mt: 2 }}>
        <Button
          variant="contained"
          color="warning"
          startIcon={<SaveIcon />}
          onClick={handleSave}
          size="small"
          disabled={!isButtonEnabled || saving}
        >
          {saving ? 'Saving...' : 'Save Checklist'}
        </Button>
      </Grid>
    </Box>
  );
};

export default SettlementCheckList;